import { useTranslation } from 'react-i18next';

import { BevelWindow } from '@/components/prototype/bevel-window';
import { PageHeader } from '@/components/prototype/page-header';

/*
 * Terms + Privacy. The prose lives in the `legal` locale bundle (the plan
 * replaces the old CMS pages with static copy in the SPA). Kept as plain
 * sections - no external markdown lib, and no user-supplied HTML.
 */

const HEADING = 'font-display text-strong text-xs uppercase';
const SECTION = 'flex flex-col gap-3 font-sans text-sm text-text';

export default function LegalPage() {
  const { t } = useTranslation('legal');

  return (
    <div className="mx-auto max-w-[820px] px-4 py-6 sm:px-5">
      <PageHeader eyebrow={t('eyebrow')} title={t('title')} subtitle={t('subtitle')} />

      <div className="mt-8 flex flex-col gap-6">
        <BevelWindow title={t('terms.title')}>
          <section id="terms" className={SECTION}>
            <p>{t('terms.intro')}</p>
            <h3 className={HEADING}>{t('terms.fairPlayHeading')}</h3>
            <p>{t('terms.fairPlayBody')}</p>
            <h3 className={HEADING}>{t('terms.accountsHeading')}</h3>
            <p>{t('terms.accountsBody')}</p>
            <h3 className={HEADING}>{t('terms.availabilityHeading')}</h3>
            <p>{t('terms.availabilityBody')}</p>
          </section>
        </BevelWindow>

        <BevelWindow title={t('privacy.title')}>
          <section id="privacy" className={SECTION}>
            <p>{t('privacy.intro')}</p>
            <h3 className={HEADING}>{t('privacy.shareHeading')}</h3>
            <p>{t('privacy.shareBody')}</p>
            <h3 className={HEADING}>{t('privacy.analyticsHeading')}</h3>
            <p>{t('privacy.analyticsBody')}</p>
            <h3 className={HEADING}>{t('privacy.choicesHeading')}</h3>
            <p>{t('privacy.choicesBody')}</p>
          </section>
        </BevelWindow>
      </div>
    </div>
  );
}
